import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { usePermissions } from "layouts/Admin";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { CustomSwitch } from "components/common/Switch";

import {
  fetchMiscRates,
  miscRatesSelector,
  removeMultipleMiscRates,
  changeMiscRateStatus,
} from "slices/miscRateSlice";

import AddMiscRate from "components/miscellaneous/AddMiscRateForm";
import { convertTimeToUTCFormatted } from "helpers/convertTimeToUTC";

function MiscellaneousRatesList() {
  const dispatch = useDispatch();
  const { checkPermission } = usePermissions();

  const {
    miscRates,
    last_page: totalPages,
    loader,
    total,
    current_page,
    per_page: pageLength,
  } = useSelector(miscRatesSelector);

  const [addForm, setAddForm] = useState({ show: false, item: {} });
  const refAddButton = React.useRef(null);

  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({
    sortBy: "certification_type",
    sortDirection: "asc",
  });

  React.useEffect(() => {
    dispatch(fetchMiscRates());
  }, []);

  const handleAddPopUp = (item) => {
    setAddForm({ show: true, item });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, { className: "successToast" });
      setSelectedItems([]);
      setSelectAll(false);
      dispatch(fetchMiscRates());
      hideConfirmDialog();
    } else {
      toast.error(message, { className: "errorToast" });
    }
  };

  const showConfirmDialog = () => setDeleteModal(true);
  const hideConfirmDialog = () => setDeleteModal(false);

  const handleRemoveItems = () => {
    dispatch(removeMultipleMiscRates({ ids: selectedItems }, submitCallback));
    setDeleteModal(false);
  };

  const handleChange = (e) => {
    const id = e.target.dataset.value;
    setSelectedItems(
      selectedItems.includes(id)
        ? selectedItems.filter((item) => item !== id)
        : [...selectedItems, id]
    );
  };

  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
      setSelectAll(false);
      return;
    }
    setSelectAll(true);
    // setSelectedItems(miscRates?.map((rate) => rate.id.toString()));
    const filtered = miscRates
      ?.filter(
        (rate) =>
          rate.certification_type !== "certified" &&
          rate.certification_type !== "non-certified"
      )
      ?.map((rate) => rate.id.toString());

    setSelectedItems(filtered);
  };

  const handlePageChange = React.useCallback((page) => {
    dispatch(fetchMiscRates(page));
  }, []);

  const handleClose = () => {
    setAddForm({ show: false, item: {} });
  };

  //#region TABLE HEAD
  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      dispatch(fetchMiscRates(current_page, { sortBy, sortDirection: dir, search: searchTerm }));
    };

    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
            {checkPermission("Delete Miscellaneous Rates") && (
              <label className="custom-checkbox checkbox">
                <input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} />
                <span className="checkmark"></span>
              </label>
            )}
          </div>
        </th>
        <th className="col">
          <TableHeaderItem title="Certification Type" sortBy="certification_type" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        <th className="col">Pay Rate</th>
        <th className="col">
          <TableHeaderItem title="Created At" sortBy="created_at" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        {checkPermission("Status Miscellaneous Rates") && <th className="col">Status</th>}
        {checkPermission("Edit Miscellaneous Rates") && <th className="col">Actions</th>}
      </tr>
    );
  }, [selectAll, searchTerm, sortConfig, current_page]);
  //#endregion

  //#region TABLE BODY
  const renderTableContent = React.useCallback(() => {
    return miscRates?.map((rate, index) => (
      <MiscRateItem
        key={rate.id}
        rate={rate}
        index={index}
        selectedItems={selectedItems}
        handleChange={handleChange}
        handleAddPopUp={handleAddPopUp}
        current_page={current_page}
        pageLength={pageLength}
        checkPermission={checkPermission}
      />
    ));
  }, [miscRates, selectedItems]);
  //#endregion

  return (
    <ListLayout
      heading="Miscellaneous Rates"
      title=""
      buttonTitle="Add Miscellaneous Rate"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      addButtonDisabled={!checkPermission("Create Miscellaneous Rates")}
      fetchList={fetchMiscRates}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => (
        <AddMiscRate item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission("Status Miscellaneous Rates")} />
      )}
      refAddButton={refAddButton}
      refAddPopUp="#miscRateModal"
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddPopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      disableBootstrap={true}
      noOfItems={total}
      searchPlaceholder="Search Miscellaneous Rates..."
    >
      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  );
}

const MiscRateItem = ({
  rate,
  index,
  selectedItems,
  handleChange,
  handleAddPopUp,
  current_page,
  pageLength,
  checkPermission,
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState(rate?.status);

  React.useEffect(() => {
    setStatus(rate?.status);
  }, [rate]);


  console.log(status , 'ststatusastasstatustatustustus')
  const getBackgroundStyle = (status) => (status === 0 ? { background: "#f4f4f4" } : {});

  const serial = useMemo(() => index + 1 + (current_page - 1) * pageLength, [current_page, pageLength]);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0);
    dispatch(changeMiscRateStatus(id, { status: s ? 1 : 0 }));
  };

  const isDefaultRate = ["non-certified", "certified"].includes(
    rate.certification_type.toLowerCase()
  );
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission("Delete Miscellaneous Rates") && !isDefaultRate && (
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="select-all"
                data-value={rate.id}
                checked={selectedItems.includes(rate.id.toString())}
                onChange={handleChange}
              />
              <span className="checkmark"></span>
            </label>
          )}
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>{rate.certification_type}</td>
      <td style={getBackgroundStyle(status)}>{rate.pay_rate}</td>
      <td style={getBackgroundStyle(status)}>{convertTimeToUTCFormatted(rate.created_at)}</td>
      {checkPermission("Status Miscellaneous Rates") && (
        <td style={getBackgroundStyle(status)}>
          <div className="row_check">
            <CustomSwitch handleChange={(s) => handleStatusChange(rate.id, s)} checked={rate?.status} />
          </div>
        </td>
      )}
      <td style={getBackgroundStyle(status)}>
        {checkPermission("Edit Miscellaneous Rates") && !isDefaultRate ? (
          <div className="row_check">
            <button
              className="table_edit"
              onClick={() => handleAddPopUp({ ...rate, status })}
            >
              Edit
            </button>
          </div>
        ) : null /* empty cell for seeded record */}
      </td>
    </tr>
  );
};

export default MiscellaneousRatesList;
